module.exports = __webpack_public_path__ + "img/U1F921.54bc199a.png";